<script>
import App from "./cards/App";
import OnDemand from "./cards/OnDemand";
import Products from "./cards/Products";
import Professionals from "./cards/Professionals";
export default {
  components: {
    App,
    OnDemand,
    Products,
    Professionals
  },

  data() {
    return {
      mounted: false
    };
  },

  mounted() {
    this.mounted = true;
  }
};
</script>

<template>
  <div>
    <transition-group name="down" mode="out-in">
      <App v-if="mounted" style="transition-delay: 250ms" key="first" />
      <OnDemand v-if="mounted" style="transition-delay: 250ms" key="second" />
      <Products v-if="mounted" style="transition-delay: 500ms" key="third" />
      <Professionals v-if="mounted" style="transition-delay: 750ms" key="fourth" />
    </transition-group>
  </div>
</template>

<style scoped>
div {
  display: flex;
  flex-direction: column;
}

*:not(:last-child) {
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/components/InfoCards/Index.vue